import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { AlertCircle, LogIn, RefreshCw } from 'lucide-react';

const SessionExpired = ({ onRetry, onLogin }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogin = () => {
    logout();
    navigate('/login');
  };

  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    } else {
      // Force a page reload to retry authentication
      window.location.reload();
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-orange-100 mb-4">
            <AlertCircle className="h-8 w-8 text-orange-600" />
          </div>
          
          <h2 className="text-2xl font-semibold text-gray-900 mb-2">
            Session Expired
          </h2>
          
          <p className="text-gray-600 mb-6">
            Your session has expired or you have been logged out. Please log in again to continue.
          </p>
          
          <div className="space-y-3">
            <button
              onClick={handleLogin}
              className="w-full flex items-center justify-center px-4 py-3 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
            >
              <LogIn className="h-4 w-4 mr-2" />
              Log In Again
            </button>
            
            <button
              onClick={handleRetry}
              className="w-full flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
            >
              <RefreshCw className="h-4 w-4 mr-2" />
              Try Again
            </button>
          </div>
          
          <p className="text-xs text-gray-500 mt-4">
            If this problem persists, please contact support.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SessionExpired;
